<template>
  <div>
    <label v-if="label">{{ label }}</label>
    <vSelect
      :options="options"
      v-model="selection"
      :reduce="(option) => option.id"
      @input="select"
      :disabled="disabled"
      :searchable="searchable"
      :autoscroll="false"
      :clearable="clearable"
      :placeholder="placeholder"
      :deselectFromDropdown="deselectFromDropdown"
      :closeOnSelect="closeOnSelect"
      :closeOnClick="closeOnClick"
      :style="test"
      :selectable="selectable">
      <template v-slot:no-options="{ searching }">
        <template v-if="searching">{{ $t('item.no_results') }}</template>

        <span slot="no-options" @click="$refs.select.open = false">
          {{ $t('select_and_tables.no_options') }}
        </span>
      </template>

      <template slot="option" slot-scope="option">
        <div :class="getClass(option)" :style="getStyle(option)">
          <b-icon v-if="option.icon" :icon="option.icon" :variant="option.variant" scale="1"></b-icon>
          <b-badge v-if="option.badge" pill :variant="option.variant">{{ option.badge }}</b-badge>
          {{ option.label }} 
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div :class="getClass(option)" :style="getStyle(option)">
          <b-icon v-if="option.icon" :icon="option.icon" :variant="option.variant" scale="1"></b-icon>
          <b-badge v-if="option.badge" pill :variant="option.variant">{{ option.badge }}</b-badge>
          <span v-if="option.caption">{{ option.caption }}</span>
          <span v-else>{{ option.label }}</span>
        </div>
      </template>
     
        

    </vSelect>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
export default {
  name: 'SelectList',
  components: { vSelect },
  props: {
    label: { type: String, default: null },
    options: { default: null },
    value: { default: null },
    disabled: { type: Boolean, default: false },
    searchable: { type: Boolean, default: true },
    clearable: { type: Boolean, default: false },
    closeOnSelect: { type: Boolean, default: true },
    closeOnClick: { type: Boolean, default: true },
    deselectFromDropdown: { type: Boolean, default: true },
    placeholder: { default: null },
    selectable: { type: Function, default: () => true }

  },
  data: function () {
    return {
      selection: '',
    }
  },
  computed: {
    test(){
      return "widt: 0" 
    }
  },

  watch: {
    value: function (newVal, oldVal) {
      if (newVal != oldVal) this.selection = newVal
      //console.log(oldVal + " -> " + newVal);
    },
  },

  methods: {
    select(value) {
      //console.log(this.value + " / " + value);
      //this.$emit('selectItem', items[0]);
      this.$emit('select', value)
    },
    getClass(option){
      let classes = "";
      if(option.class) classes += option.class + " ";
      if(option.heading) classes += "heading ";
      if(option.caption) classes += "caption ";
      if(option.group) classes += "group-" + option.group;
      return classes;
    },
    getStyle(option){
      let style = "";
      if(option.style) style += option.style;
      if(option.font) style += "font:" + option.font + ";"
      if(option.color) style += "color:" + option.color + ";"
      if(option.background) style += "background-color: " + option.background + ";"
      return style;
    }
  },
  created() {
    //console.log("created: "+this.label+" / "+this.value);
    this.selection = this.value
  },
}
</script>

<style scoped lang="scss">

.badge {
  min-width: 30px;
  margin-right: 5px;
}

</style>